import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AppColors } from '../utils/utils';

const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  width: 'fit-content',
  background: AppColors.orangeBGColor,
  borderRadius: '40px',
  border: 0,
  color: 'white',
  padding: '6px 16px', // xs default
  textTransform: 'none',
  fontSize: 'clamp(0.8rem, 2vw, 1.2rem)',
  fontWeight: 600,
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  transition: '0.3s',

  [theme.breakpoints.up('sm')]: {
    padding: '4px 18px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '4px 24',
  },
  [theme.breakpoints.up('lg')]: {
    padding: '6px 28px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: '6px 32px',
  },

  '&:hover': {
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.3)',
  },
}));

export const OrangeRoundedButton: React.FC<ButtonProps> = (props) => {
  return <StyledButton variant='contained' {...props} />;
};
